export default "__VITE_ASSET__C$M3CdkM__"